module.exports = __webpack_public_path__ + "img/logo.d41c9f4a.png";